import CryptoJS from 'crypto-js';

const SECRET_KEY = 'iZSwcqe8iUPuM482cf0vQynVDy3BPqA';

// helper functions

const encrypt = (item) => CryptoJS.AES.encrypt(JSON.stringify(item), SECRET_KEY);
const decrypt = (item) => JSON.parse(CryptoJS.AES.decrypt(item, SECRET_KEY).toString(CryptoJS.enc.Utf8));

const getStorageItem = (key) => {
  const config = localStorage.getItem(key);
  if (!config) return null;
  try {
    return JSON.parse(decrypt(config));
  } catch (e) {
    return null;
  }
};

const setStorageItem = (key, value) => {
  localStorage.setItem(key, encrypt(JSON.stringify(value)));
};

const clearStorageItem = (key) => {
  if (localStorage.getItem(key)) localStorage.removeItem(key);
};

export {
  getStorageItem,
  setStorageItem,
  clearStorageItem,
};
